var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.View.layout = ssg.View.layout || {};

ssg.View.layout.cmLogo = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};

ssg.View.layout.cmLogo.prototype = $.extend({
  init: function () {
    this._assignElements();
    this._attachEventHandlers();
    this._initAnimation();
  },
  _assignElements: function () {
    this._welCmLogo = $('.cm_logo');
    this._welCmLogoHome = this._welCmLogo.find('.cm_logo_home');
    this._welCmLogoToggle = this._welCmLogo.find('.cm_logo_toggle');
    this._welCmLogoMallList = this._welCmLogo.find('.cm_logo_malllist');
  },
  _attachEventHandlers: function () {
    this._welCmLogoHome.on('click', '.cm_logo_toggle', $.proxy(this._onClickCmLogoToggle, this));
    this._welCmLogo.on('click', '.cm_logo_dim', $.proxy(this._onClickCmLogoDim, this));
    this._welCmLogoMallList.on('click', '.cm_logo_mallbtn', $.proxy(this._onClickCmLogoMallBtn, this));
  },
  _initAnimation: function () {
    if (this._welCmLogoHome.hasClass('cm_logo_main')) {
      this._welCmLogoHome.addClass('ani');
    }
  },
  _onClickCmLogoToggle: function (e) {
    e.preventDefault();
    this._showLayer();
  },
  _onClickCmLogoDim: function () {
    this._hideLayer();
  },
  _onClickCmLogoMallBtn: function (e) {
    this._hideLayer();
  },
  _showLayer: function () {
    this._welCmLogo.addClass('on');
    this._welCmLogoToggle.addClass('on');
  },
  _hideLayer: function () {
    this._welCmLogo.removeClass('on');
    this._welCmLogoToggle.removeClass('on');
  }
}, ssg.Event.emitter);

ssg.View.layout.cmFloatingTalk = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};

ssg.View.layout.cmFloatingTalk.prototype = $.extend({
  init: function () {
    this._assignElements();
    this._attachEventHandlers();
  },
  _assignElements: function () {
    this._welBtnArea = $('.cmfloating_btntoggle');
    this._welDim = this._welBtnArea.find('.cmfloating_dim');
  },
  _attachEventHandlers: function () {
    this._welBtnArea.on('click', '.cmfloating_btnchat', $.proxy(this._onClickToggle, this));
    this._welDim.on('click', $.proxy(this._onClickDim, this));
  },
  _onClickToggle: function (e) {
    e.preventDefault();
    var welBtn = $(e.currentTarget),
      welBtnArea = welBtn.closest('.cmfloating_btntoggle');

    welBtnArea.toggleClass('on');
    if (welBtn.is('[aria-expanded]')) {
      welBtn.attr('aria-expanded', (welBtn.attr('aria-expanded') == "false" ? true : false));
    }
  },
  _onClickDim: function (e) {
    var welTarget = $(e.currentTarget),
      welBtnArea = welTarget.closest('.cmfloating_btntoggle'),
      welBtn = welBtnArea.find('cmfloating_btnchat');

    welBtnArea.removeClass('on');
    if (welBtn.is('[aria-expanded]')) {
      welBtn.attr('aria-expanded', false);
    }
  }
}, ssg.Event.emitter);

var skySsgtalk = function () {
  function showSellerDtl() {
    var welBtnsellerDtl = $('.cmfloating_btnseller_dtl');
    if (welBtnsellerDtl.length > 0) {
      welBtnsellerDtl.addClass('on');

      if (!(welBtnsellerDtl.hasClass('is_timer'))) {
        welBtnsellerDtl.addClass('is_timer');
        ssg.util.wait(2000).done(function () {
          welBtnsellerDtl.removeClass('on');
          welBtnsellerDtl.removeClass('is_timer');
        });
      }
    }
  }

  function onPush(welTarget) {
    $(welTarget).addClass('on');

    if (!($(welTarget).hasClass('is_timer'))) {
      $(welTarget).addClass('is_timer');
      ssg.util.wait(2000).done(function () {
        $(welTarget).removeClass('on');
        $(welTarget).removeClass('is_timer');
      });
    }
  }

  function offPush(welTarget) {
    $(welTarget).removeClass('on');
  }

  return {
    showSellerDtl: showSellerDtl,
    onPush: onPush,
    offPush: offPush
  };
}();

var oSsgLazyLoad = new LazyLoad({
	elements_selector: ".ssg_lazy"
});

ssg.View.history = function (htOptions) {
  $.extend(this, htOptions || {});
  this.init();
};

ssg.View.history.prototype = $.extend({
  iscroll: null,
  init: function () {
    this._assignElements();
    this._attachEventHandlers();
    this.initScroll();
  },
  initScroll: function () {
    if ($('#_cmhistory_scroll').length > 0) {
      this.iscroll = new SSGIScroll('#_cmhistory_scroll', {
        eventPassthrough: 'horizontal'
      });
    }
  },
  refreshScroll: function () {
    this.iscroll.refresh();
  },
  moveScrollTop: function () {
    this.iscroll.scrollTo(0, 0);
  },
  _assignElements: function () {
    this._welHistoryWrap = $('#_cmhistory_wrap');
    this._welHistoryScrollArea = this._welHistoryWrap.find('.cmhistory_ct');
    this._welHistoryTop = this._welHistoryWrap.find('.cmhistory_top');
    this._welHistoryTit = this._welHistoryWrap.find('.cmhistory_tit');
    this._welHistoryCtrl = this._welHistoryWrap.find('.cmhistory_ctrl');
    this._welHistorySort = this._welHistoryWrap.find('.cmhistory_sort');
    this._welHistoryList = this._welHistoryWrap.find('.cmhistory_lst');
  },
  _attachEventHandlers: function () {
    this._welHistoryTit.on('click', '.cmhistory_bt_edit', $.proxy(this._onClickEdit, this));
    this._welHistoryTit.on('click', '.cmhistory_bt_cancel', $.proxy(this._onClickCancel, this));
    this._welHistorySort.on('click', 'li button', $.proxy(this._onClickSort, this));
    jindo.m.bindRotate($.proxy(this._onRotate, this));
    $(window).on("resize", $.debounce(150, $.proxy(this._onRotate, this)));
  },
  _onClickEdit: function (e) {
    e.preventDefault();
    this._welHistoryWrap.addClass('edit');
  },
  _onClickCancel: function (e) {
    e.preventDefault();

    this._welHistoryList.find('input:checkbox').prop('checked', false);
    this._welHistoryWrap.removeClass('edit');
  },
  _onClickSort: function (e) {
    e.preventDefault();

    var welTarget = $(e.currentTarget),
      welTargetList = welTarget.parents('li');

    if (welTargetList.hasClass('on')) {
      welTargetList.removeClass('on');
    }
    else {
      welTargetList.addClass('on');
    }
  },
  _onRotate: function () {
    this.iscroll && this.refreshScroll();
  }
}, ssg.Event.emitter);

$(function () {
  if ($('.cm_logo').length > 0) {
    var oSsgViewLayoutCmLogo = new ssg.View.layout.cmLogo();
  }
  if ($('.cmfloating_btnarea').length > 0) {
    var oSsgViewLayoutCmFloatingTalk = new ssg.View.layout.cmFloatingTalk();
  }
  // ui-app.js
  $('.cm_bt_share').morph({
    useTransform: false,
    preventTouch: true,
    preventScrollLock: false,
    disableScroll: false
  });
  if ($('._mcom_newmall_sticky').length > 0) {
    $("._mcom_newmall_sticky").waypoint('sticky');
  }
});


/*
 * [공통] 카테고리 LNB
 * 스타필드 카테고리 JSON에 ID값 없음 : 스토리지 키값은 NM, 링크 이동 시 LINK_URL로 대체
 */
ssg.View.layout.eventBus = new Vue();

ssg.View.layout.categoryItem = {
  name: 'category-item',

  template: `
    <li>
      <a 
        :class="classObject"
        :aria-expanded="open"
        :href="items.LINK_URL? items.LINK_URL : '#'"
        @click.prevent="toggle(items.DTH, items.ID || items.NM, items.ID || items.LINK_URL, items.SN)"
      >
          <span class="clnb_item_tx">{{ items.NM }}</span>
          <span class="clnb_item_ic" v-if="isFolder && !titled">[{{ open ? '-' : '+' }}]</span>
      </a>
      <transition name="clnb-slide" @after-enter="afterEnter" @after-leave="afterLeave">
        <ul ref="subset" v-show="open" v-if="isFolder">
          <category-item class="clnb_sub_item"
            v-for="(item, index) in items.L"
            :key="index"
            :items="item"
            :storage="storage"
            :maxdepth="maxdepth"
            :selected="selected"
            :parent="parents"
            :open="storage[item.DTH] == (item.ID || item.NM)"
            @select="select"
            @show="afterShow"
            @hide="afterHide">
          </category-item>
        </ul>
      </transition>
    </li>
  `,

  props: {
    items: Object,
    storage: Array,
    open: Boolean,
    titled: Boolean,
    maxdepth: Number,
    selected: String,
    parent: Array,
  },

  computed: {
    parents() {
      return this.parent.concat([{
        DTH: this.items.DTH,
        ID: this.items.ID || this.items.NM
      }])
    },
    isFolder() {
      return (this.maxdepth && this.maxdepth == this.items.DTH) ? false : (this.items.L && this.items.L.length)
    },
    isSelected() {
      return this.storage[this.items.DTH] == (this.items.ID || this.items.NM)
    },
    // 기획전, 스페셜 카테고리
    isCustom() {
      return this.items.TP == "20"
    },
    // 전체보기
    isAll() {
      return this.items.TP == "C10"
    },
    // 서브타이틀
    isSiblingTitle() {
      return this.items.TP == "C20"
    },
    classObject() {
      return {
        clnb_item_link: true,
        titled: this.titled,
        folder: this.isFolder,
        selected: this.isSelected,
        custom: this.isCustom,
        all: this.isAll,
        st: this.isSiblingTitle,
        sm: this.isSiblingTitle && this.items.NM === "신세계몰",
        sd: this.isSiblingTitle && this.items.NM === "신세계백화점",
      }
    },
  },

  methods: {
    toggle(index, value, code, siteNo) {
      if (this.isSiblingTitle) {
        return
      } else if (this.isFolder) {
        this.$emit('select', index, (!this.open) ? value : '');
      } else {
        ssg.View.layout.eventBus.$emit('lnb:category:link', code, siteNo);
      }
    },
    afterEnter() {
      this.$emit('show', this.$el);
    },
    afterLeave() {
      this.$emit('hide');
    },
    afterShow(elem) {
      this.$emit('show', elem);
    },
    afterHide() {
      this.$emit('hide');
    },
    select(index, value) {
      this.$emit('select', index, value);
    },
  },

  created() {
    if (this.selected && this.selected == (this.items.ID || this.items.NM)) {
      this.parents.forEach((elem) => {
        this.storage.splice(elem.DTH, 1, elem.ID);
      });
    }
  },
};

ssg.View.layout.categoryList = {
  name: 'category-list',

  template: `
    <ul role="navigation" aria-label="공통 카테고리">
      <category-item
        v-for="(item, index) in items.CTG"
        :class="['clnb_item', {titled: titled}]"
        :key="index"
        :items="item"
        :storage="storage"
        :maxdepth="maxdepth"
        :selected="selected"
        :parent="[]"
        :titled="titled"
        :open="titled ? true : storage[item.DTH] == (item.ID || item.NM)"
        @select="saveStorage"
        @show="afterShow"
        @hide="afterHide">
      </category-item>
    </ul>
  `,

  components: {
    CategoryItem: ssg.View.layout.categoryItem
  },

  props: {
    data: {
      type: String,
      required: true,
    },
    titled: {
      type: Boolean,
      default: false,
    },
    maxdepth: Number,
  },

  data() {
    return {
      items: {},
      storage: [],
      selected: '',
    }
  },

  methods: {
    fetchData() {
      fetch(this.data)
        .then(res => res.json())
        .then(data => {
          this.items = data;
          this.initStorage();
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    initStorage() {
      this.titled && this.storage.push(this.items.CTG[0].ID || this.items.CTG[0].NM);
      this.storage.push('');
    },
    getSelected() {
      var selected = "",
        urlParams = null;

      if ('URLSearchParams' in window) {
        urlParams = new URLSearchParams(window.location.search);

        // ssg, sm, sd, howdy
        if (urlParams.has('ctgId')) {
          selected = urlParams.get('ctgId');
        }
        // em, traders, boots, tv, si
        else if (urlParams.has('dispCtgId')) {
          selected = urlParams.get('dispCtgId');
        }
        // sf
        else if (urlParams.has('strId')) {
          selected = window.location.href;
        }
        // 20190605 하위 브라우저 지원 제거
        // } else if($.url($(location).attr('href'))){
        //   urlParams = $.url($(location).attr('href'));

        //   // ssg, sm, sd, howdy
        //   if (urlParams.param('ctgId')){
        //     selected = urlParams.param('ctgId');
        //   }
        //   // em, traders, boots, tv, si
        //   else if (urlParams.param('dispCtgId')) {
        //     selected = urlParams.param('dispCtgId');
        //   }
        //   // sf
        //   else if (urlParams.param('strId')) {
        //     selected = window.location.href;
        //   } 
      }
      this.selected = selected;
    },
    saveStorage(index, value) {
      // 동일한 카테고리를 선택했을 때
      if (this.storage[index] == value) {
        return
      }
      // 타이틀 타입의 카테고리를 선택했을 때
      if (this.titled && index == 0) {
        return
      }
      this.storage.length = index;
      this.storage.push(value);
    },
    afterShow(elem) {
      this.$emit('show', elem);
    },
    afterHide() {
      this.$emit('hide');
    },
  },

  created() {
    this.fetchData();
    this.getSelected();
  },
};

const oSSGViewLnb = new Vue({
  name: 'common-lnb',

  el: '#_clnb',

  components: {
    CategoryList: ssg.View.layout.categoryList
  },

  data() {
    return {
      iscroll: null,
    }
  },

  methods: {
    initScroll() {
      if (document.getElementById('_clnb')) {
        this.iscroll = new SSGIScroll('#_clnb', {
          tab: true,
          eventPassthrough: 'horizontal',
        });
      }
    },
    refreshScroll() {
      var elem = this.iscroll.wrapper;
      var isVisible = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

      if (isVisible) {
        this.iscroll.refresh();
      }
    },
    showItem(elem) {
      var positionY = elem.getBoundingClientRect().top || 0;

      this.refreshScroll();
      if (positionY < 0 || positionY + elem.clientHeight >= window.innerHeight) {
        this.iscroll.scrollToElement(elem);
      }
    },
    hideItem() {
      this.refreshScroll();
    },
    setItem() {
      var aSelectTarget = document.querySelectorAll("#_clnb_nav .folder.selected");

      this.refreshScroll();
      if (aSelectTarget.length && !(aSelectTarget.length == 1 && aSelectTarget[0].classList.contains('titled'))) {
        this.iscroll.scrollToElement(aSelectTarget[aSelectTarget.length - 1]);
      }
    },
    orientationChange() {
      this.iscroll && this.refreshScroll();
    },
  },

  created() {
    ssg.View.layout.eventBus.$on('lnb:show', () => this.setItem());
    ssg.View.layout.eventBus.$on('lnb:refresh', () => this.refreshScroll());
  },

  mounted() {
    this.$nextTick(() => {
      this.initScroll();
    });
    window.addEventListener('orientationchange', $.debounce(200, this.orientationChange));
  },

  updated() {
    this.$nextTick(() => {
      this.refreshScroll();
    });
  },

  beforeDestroy() {
    ssg.View.layout.eventBus.$off('lnb:show');
    ssg.View.layout.eventBus.$off('lnb:refresh');
    ssg.View.layout.eventBus.$off('lnb:category:link');
  },
});